import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useCallback } from 'react';
import { createFriendAddOutbound, createFriendRemoveOutbound } from '../../api/outbound/friendsOutbounds';
import { OpenModalContainer } from '../../components/openModalContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
export const AcceptFriendModal = ({ username, onClose }) => {
    const socketSend = useSocketSend();
    const onClickAccept = useCallback(() => {
        socketSend(createFriendAddOutbound(username));
        onClose();
    }, [username, onClose, socketSend]);
    const onClickDeny = useCallback(() => {
        socketSend(createFriendRemoveOutbound(username));
        onClose();
    }, [username, onClose, socketSend]);
    return (_jsx(OpenModalContainer, { title: `Friend Request from ${username}`, onClose: onClose, children: _jsxs(DialogActions, { children: [_jsx(Button, { variant: 'contained', onClick: onClickAccept, children: "Accept" }), _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickDeny, children: "Deny" })] }) }));
};
